export default {"src":"/_next/static/media/calendarCancel_40.9e1dbdf5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};